"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValue = exports.formatObject = exports.generateObjectSDRN = void 0;
var utils_1 = require("./utils");
var objectTypeContentMapping = {
    classifiedad: 'classified',
    notificationcontent: 'notification',
    businesstransaction: 'transaction',
    uielement: 'element',
};
var getObjectContentByType = function (type) {
    var _a;
    if (type === void 0) { type = ''; }
    return ((_a = objectTypeContentMapping[type.toLowerCase()]) !== null && _a !== void 0 ? _a : type.toLowerCase());
};
function generateObjectSDRN(id, providerId, type) {
    if (((0, utils_1.isString)(id) || (0, utils_1.isNumber)(id)) &&
        (0, utils_1.isString)(providerId) &&
        (0, utils_1.isString)(type)) {
        var contentType = getObjectContentByType(type);
        return "sdrn:".concat(providerId, ":").concat(contentType, ":").concat(id);
    }
}
exports.generateObjectSDRN = generateObjectSDRN;
/**
 * Format UIElement.
 *
 * This will transform the object to a valid UIElement.
 * When building the id of the UIElement it will primarily
 * try to use 'page.id' and page.type (if available).
 * If page is not available it will fall back to use
 * 'target.id' and 'target.type' when calling sdrn().
 * If neither page nor target is available it will
 * use default type from the object.
 *
 * @private
 * @param {object} data object and provider is mandatory, rest is optional.
 */
function formatUIElement(_a) {
    var object = _a.object, provider = _a.provider, page = _a.page, target = _a.target;
    var _b = object || {}, id = _b.id, type = _b.type, custom = _b.custom, rest = __rest(_b, ["id", "type", "custom"]);
    var _c = page || {}, pageId = _c.id, pageType = _c.type;
    var _d = target || {}, targetId = _d.id, targetType = _d.type;
    var providerId = (provider || {}).id;
    var uiElementId = pageType || targetType
        ? "".concat(generateObjectSDRN(pageId || targetId, providerId, pageType || targetType) || '', ":element:").concat(id)
        : generateObjectSDRN(id, providerId, type);
    var baseObject = {
        '@id': uiElementId,
        '@type': type,
    };
    if (custom) {
        baseObject['spt:custom'] = custom;
    }
    return Object.assign({}, baseObject, rest);
}
function formatDefaultObject(_a) {
    var object = _a.object, provider = _a.provider;
    var _b = object || {}, id = _b.id, _c = _b.type, type = _c === void 0 ? 'Content' : _c, custom = _b.custom, rest = __rest(_b, ["id", "type", "custom"]);
    var providerId = (provider || {}).id;
    var objectId = generateObjectSDRN(id, providerId, type);
    var baseObject = {};
    if (objectId) {
        baseObject = {
            '@id': objectId,
            '@type': type,
        };
    }
    if (custom) {
        baseObject['spt:custom'] = custom;
    }
    return Object.assign({}, baseObject, rest);
}
function formatAccount(_a) {
    var object = _a.object;
    var _b = object || {}, id = _b.id, _c = _b.realm, realm = _c === void 0 ? 'schibsted.com' : _c, _ = _b.type, custom = _b.custom, rest = __rest(_b, ["id", "realm", "type", "custom"]); // type is dropped
    if (!id) {
        return;
    }
    var baseObject = {
        '@id': "sdrn:".concat(realm, ":user:").concat(id),
        '@type': 'Account',
        accountId: id,
    };
    if (custom) {
        baseObject['spt:custom'] = custom;
    }
    return Object.assign({}, baseObject, rest);
}
var objectFormatterMapping = {
    UIElement: formatUIElement,
    Account: formatAccount,
};
function getObjectFormatter(type) {
    return objectFormatterMapping[type] || formatDefaultObject;
}
/**
 * Format object.
 *
 * This function will recursively format itself and all nested object.
 * The initialPage parameter is optional and will be used in the recursive
 * nature to always pass in the root object page to each formatting.
 *
 * @private
 * @param {object} input
 * @param {object|undefined} pageInput Optional
 */
var formatObject = function (input, pageInput) {
    var _a = (input || {}).object, objectInput = _a === void 0 ? {} : _a;
    var pageInObject = objectInput.page;
    var page = pageInput || pageInObject;
    var evaluatedObjectInput = Object
        .keys(objectInput)
        .reduce(function (accl, key) {
        var _a, _b, _c;
        var prop = objectInput[key];
        if ((0, utils_1.isArray)(prop)) {
            return __assign(__assign({}, accl), (_a = {}, _a[key] = prop.map(function (o) {
                if ((0, utils_1.isObject)(o)) {
                    return (0, exports.formatObject)(Object.assign({}, input, { object: o }), page);
                }
                return o;
            }), _a));
        }
        else if ((0, utils_1.isObject)(prop)) {
            return __assign(__assign({}, accl), (_b = {}, _b[key] = (0, exports.formatObject)(Object.assign({}, input, { object: prop }), page), _b));
        }
        return __assign(__assign({}, accl), (_c = {}, _c[key] = prop, _c));
    }, {});
    var output = Object.assign({}, input, { page: page, object: evaluatedObjectInput });
    return getObjectFormatter(objectInput.type)(output);
};
exports.formatObject = formatObject;
exports.default = exports.formatObject;
var defaultValue = function () { return undefined; };
exports.defaultValue = defaultValue;
